<style lang="scss">
  @import "@/assets/scss/vuexy/components/minMaxItem";
</style>
<template>
  <div class="m-3 px-2 py-4 border-2 container-item">
      <feather-icon
      icon="EditIcon"
      @click="edit = true"
      class="float-right cursor-pointer" 
      svgClasses="hover:text-primary"
      v-if="!edit && (url !== undefined && url !== null)"/>
      <feather-icon v-if="edit" 
      @click="edit = false" 
      icon="XIcon" 
      svgClasses="hover:text-primary mx-2" 
      class="float-right cursor-pointer "/>
      <feather-icon
      icon="SaveIcon"
      @click="requestPassword()"
      class="float-right cursor-pointer" 
      svgClasses="hover:text-primary"
      v-if="edit"
      />
      <div class="block text-center mb-2 font-medium">{{title}}</div>
      <div class="block" v-if="!edit">
        <div class="inline-block mr-3 icon-container">
            <img class="h-8 m-auto" :src="getImgUrl(img)" v-if="img"/>
        </div>
        <div class="inline-block">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>  {{ editMin }}<span class="unit">{{unit}}</span>
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>  {{ editMax }}<span class="unit">{{unit}}</span>
            </div>
        </div>
      </div>
      <div class="block container-inputs" v-if="edit">
        <div class="text-center">
            <div>
                <span class="font-bold">{{$t("Labels.Min")}}</span>
                <vs-input-number :min="rangeMin" :max="rangeMax"  :step="step" v-model="editMin" class="text-xs"/> 
            </div>
            <div>
                <span class="font-bold">{{$t("Labels.Max")}}</span>
                <vs-input-number :min="rangeMin" :max="rangeMax" :step="step" v-model="editMax" class="text-xs"/> 
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import {request} from '@/request.js'
import {globalPassActions} from '@/globalPass'
import {empty} from '@/helpers.js'

export default {
  props:{
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 0
    },
    unit: String,
    img: String,
    title: String,
    url: String,
    paramMin: {
      type: String,
      default: ''
    },
    paramMax: {
      type: String,
      default: ''
    },
    type: String,
    uuid: {
      type: [Number, String],
      default: null
    },
    rangeMin:  {
      type: [Number, String],
      default: 0
    },
    rangeMax:  {
      type: [Number, String],
      default: 0
    },
    step: {
      type: [Number],
      default: 1
    }
  },
  data () {
    return {
      edit: false,
      editMin: 0,
      editMax: 0,
      ban: false
    }
  },
  methods: {
    getImgUrl (name) {
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      return images(`./${  name  }.svg`)
    },
    async send () {
      const params = {
        url: this.url,
        method: this.type,
        params: {}
      }
      params.params[this.paramMin] = this.editMin
      params.params[this.paramMax] = this.editMax
      if (this.uuid !== null) params.params['uuid'] = this.uuid
      await request(params).then(() => {
        this.edit = false
      }).finally(() => {
        this.edit = false
      })
    },
    requestPassword () {
      this.ban = true
      globalPassActions.show()
    }
  },
  created () {
    this.editMin = this.min || 0
    this.editMax = this.max || 0
  },
  computed: {
    isVisiblePassword () {
      return globalPassActions.getStatus()
    } 
  },
  watch: { 
    isVisiblePassword (visible) {
      if (!empty(globalPassActions.get()) && visible === false && this.ban === true) {
        this.send()
        this.ban = false
      }
        
    }
  }
}
</script>